import { DateRangePresenter } from '@/forms/components/presenters/DateRangePresenter';
import {
  FormFieldType,
  type DateRangeFormField,
  type FileFormField,
  type SingleFormField,
} from '@/forms/typings';

import type { FormFieldModule } from '../registry/field-module.types';

import { buildDateRangeInitialState } from './initialState';

export const dateRangeFieldModule: FormFieldModule = {
  type: FormFieldType.DateRange,
  Presenter: ({ field, disabled }) => (
    <DateRangePresenter field={field as DateRangeFormField} disabled={disabled} />
  ),
  flattenLeaves: field =>
    (field as DateRangeFormField).fields as Array<SingleFormField | FileFormField>,
  buildInitialState: buildDateRangeInitialState,
};
